import { render, staticRenderFns } from "./mountings.vue?vue&type=template&id=cc523138&"
import script from "./mountings.vue?vue&type=script&lang=js&"
export * from "./mountings.vue?vue&type=script&lang=js&"
import style0 from "./mountings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports